<template>
  <pop-up-layout 
    :title="$t('configuracion.moduloContrato')"
    :description="$t('reservas.contrato.descripcionIncidencias')"
    @volver="$parent.hide()"
  >
    <v-list dense>
      <v-list-tile
          v-for="(incidencia, i) in incidencias"
          :key="i"
        >
          <v-list-tile-content>
            <v-list-tile-title class="error--text">{{incidencia.description}}</v-list-tile-title>
          </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-layout justify-center>
      <v-btn
        color="primary"
        :href="pdfHref"
        download="contrato.pdf"
      >
        {{$t('reservas.contrato.verDoc')}}
      </v-btn>
    </v-layout>
  </pop-up-layout>
</template>

<script>
export default {
  props: {
    incidencias: {
      type: Array,
      required: true
    },
    pdf: {
      type: String,
      required: true
    },
  },
  data () {
    return {
    }
  },
  computed: {
    pdfHref() {
      return 'data:application/pdf;base64,' + this.pdf
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reservas/contratos/ContratoMostrarIncidencias.vue